import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

export default {

    async Movimientos(vm){
        //let datos = JSON.parse(sessionStorage.getItem('reporte'));

        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("aiclave", datos.aiclave);
        return vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/MovimientosReporte`, formData).then(response => response.data);

    },
    SolicitarNuevamente(vm, datos) {
        console.log(datos);
        return vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/SolicitarNuevamente`, datos).then(response => response.data);
    },
    ValidaDocValDigital(vm, datos) {
        vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/ValidaDocValDigital`, datos).then(response => {
                          vm.ValsoliNuevamente=response.data; 
                   });
           
    }
}